<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'스포트라이트'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <InfinityScroll style="flex: 1;" :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle">
            <div style="height: 100%; padding: 0 12px; overflow-y: scroll;">
                <div style="margin-top: 20px;">
                    <img style="width: 100%;" :src="require('@/assets/img/spot_light_test_back.png')" alt="">
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 700; line-height: 24px;">이번주 추천 인터뷰</div>
                    <div style="margin-top: 12px;">
                        <swiper style="height: 206px; border-radius: 12px; overflow: hidden;" :options="swiperOption" role="tablist">
                            <swiper-slide v-for="each, i in spotLights" :key="i + 'spotLights'" style="width: 100%; height: 100%; position: relative; border-radius: 12px; overflow: hidden; background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%);" role="tab">
                                <img style="width: 100%; height: 100%; position: absolute; z-index: -1;" :src="$resourcePath + each.thumbnail_path" alt="">
                                <!-- <img style="width: 100%; height: 100%; position: absolute; z-index: -1; object-fit: cover;" :src="require('@/assets/img/test_back.png')" alt=""> -->
                                <div @click="showInterviewDetail(each, i); $Util.sendEventClick('스포트라이트_인터뷰자세히보기')" style="position: relative; padding: 20px; height: 100%; display: flex; flex-direction: column; z-index: 1; justify-content: end;">
                                    <div style="color: #fff; font-size: 20px; font-weight: 700; line-height: 32px; margin-bottom: 4px; word-break: break-all;">{{ each.title }}</div>
                                    <div style="color: #bbb; font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.name }}</div>
                                </div>
                            </swiper-slide>
                            <div key="test" class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; top: 20px; height: 20px; text-align: right; padding-right: 20px; z-index: 10; display:inline-block;"></div>
                        </swiper>
                    </div>
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 700; line-height: 24px;">모든 스포트라이트 인터뷰</div>
                    <div style="margin-top: 28px;">
                        <div @click="showInterviewDetail(each, i); $Util.sendEventClick('스포트라이트_인터뷰자세히보기')" class="spotlight_row" style="display:flex;" v-for="each, i in allInterview" :key='i'>
                            <div style="flex:1;">
                                <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">{{each.name}}</div>
                                <div style="display: flex; gap: 24px; margin-top:4px;">
                                    <div style="font-weight: 500; line-height: 24px; flex: 1;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{each.title}}</div>
                                </div>
                                <div style="color: #606060; line-height: 20px; margin-top:8px; font-size: 12px;">{{ each.insert_date | agoDateStr }}</div>
                            </div>
                            <div style=" overflow: hidden; flex-shrink: 0; display:grid; place-items: center;">
                                <img style="width: 60px; height: 60px; border-radius: 12px;" :src="$resourcePath + each.thumbnail_path" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import MercenaryHeader from '@/components/common/MercenaryHeader'
import {PUSH_ACTION} from "../../Constants";
import InfinityScroll from "@/components/common/InfinityScroll"

export default {
    name: 'SpotLightList',
    components: { MercenaryHeader, swiper, swiperSlide, InfinityScroll },
    data() {
        return {
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                autoplay: {
                    delay: 5000
                },
                curIndex: 0,
            },
            spotLights: [],
            page: 1,
            allInterview: [],
            isEnableNextPageHandle: true,
        }
    },
    created() {
        this.getInterviewList()
        this.getAllInterviewList()
    },
    methods: {
        refresh() {
            this.spotLights = []
            this.allInterview = []
            this.page = 1
            this.getInterviewList()
            this.getAllInterviewList()
        },
        async getInterviewList() {
            const res = await this.$Axios.get('/api/team/map/list')
            this.spotLights = res.data.spotlights
        },
        handleNextPage() {
            this.page++
            this.getAllInterviewList()
        },
        showInterviewDetail(detail) {
            this.$GlobalStore.addModal('InterviewDetail', { spotlightIdx: detail.idx })
            // this.$Util.checkAppLinkPageShow();
        },
        async getAllInterviewList() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            const res = await this.$Axios.get('/api/spotlight/list', { params: parameters })
            const allInterview = res.data.spotlights

            if (allInterview.length > 0) {
                this.isEnableNextPageHandle = true
                this.allInterview = [...this.allInterview, ...allInterview]
            }
        }
    },
    mounted(){
        this.$Util.checkAppLinkPageShow(PUSH_ACTION.SPORTLIGHT_LIST);
    }
}
</script>

<style scoped>
.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}

    .spotlight_row + .spotlight_row{margin-top:30px;}
</style>